export default "__VITE_ASSET__86a928db__"